import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_posts_toolbar = _resolveComponent("posts-toolbar")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Post Filters",
    size: "sm",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_posts_toolbar, {
        filters: _ctx.filters,
        "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:filters', $event)))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["filters"])
    ]),
    _: 3
  }, 512))
}